import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AUTO_MANAGED_COUNTRY_OPTIONS, AUTO_MANAGED_STATUS_OPTIONS } from '@anytag/shared-constants';
import { useAllInfluencerCategoryOptions, useTranslateCountryOptions, useTranslateOptions } from '@anytag/shared-hooks';
import { Form } from '@anytag/shared-atoms';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { AutoManagedMoreFilter } from './AdvancedFilter';
import { AutoManagedCampaignsFilterFormValues, AutoManagedCampaignsFilterKeys } from './schemaTypes';

interface BasicFilterProps {
  onSubmit?: () => void;
}

export const BasicFilter = ({ onSubmit }: BasicFilterProps) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<AutoManagedCampaignsFilterFormValues>();
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();
  const allCountryOptions = useTranslateCountryOptions(AUTO_MANAGED_COUNTRY_OPTIONS);
  const statusOptions = useTranslateOptions(AUTO_MANAGED_STATUS_OPTIONS);

  const values = getValues();
  const numOfValidFilter =
    [
      values.minPrice,
      values.maxPrice,
      values.minCommissionRate,
      values.maxCommissionRate,
      values.marketplaceType
    ].filter((value) => (Array.isArray(value) ? !!value.length : Boolean(value))).length || 0;

  return (
    <Form.Fields>
      <TextSearchField<AutoManagedCampaignsFilterKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.Search by keyword, brand')}
      />

      <SelectorField<AutoManagedCampaignsFilterKeys>
        name="countryId"
        onSubmit={onSubmit}
        className="max-w-40"
        options={allCountryOptions}
        placeholder={t<string>('Selector.Country')}
      />

      <SelectorField<AutoManagedCampaignsFilterKeys>
        name="status"
        onSubmit={onSubmit}
        options={statusOptions}
        className="max-w-30"
        placeholder={t<string>('Selector.Status')}
      />

      <SelectorField<AutoManagedCampaignsFilterKeys>
        name="categoryIds"
        onSubmit={onSubmit}
        className="max-w-40"
        options={allInfluencerCategoryOptions}
        placeholder={t<string>('Selector.Categories')}
        multiple
      />

      <AutoManagedMoreFilter count={numOfValidFilter} onSubmit={onSubmit} />
    </Form.Fields>
  );
};
